import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';
import { getAlternativeClassifications } from '@/store/actions/classification';
import AlternativeClassificationForm from '../forms/AlternativeClassificationForm';

function AlternativeClassificationModal({ visible, onClose, submitForm, error, formProps, title }) {
  const [submit, setSubmit] = useState(false);
  const [dropdownData, setDropdownData] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      if (visible) {
        try {
          const { data } = await getAlternativeClassifications();
          if (data) {
            setDropdownData(data);
          }
        } catch (e) {
          console.log(e);
        }
      }
    };
    fetch();
  }, [visible]);

  const formSubmit = (values) => {
    submitForm(values);
    setSubmit(false);
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <AlternativeClassificationForm
            data={dropdownData}
            submitOutside={submit}
            submit={formSubmit}
            formProps={formProps}
            error={error}
          />
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            variant="outline"
            onClick={() => onClose()}
            data-testid="alt-classification-modal-close-btn"
          >
            Zavřít
          </Button>
          <Button
            key={2}
            onClick={() => setSubmit(true)}
            data-testid="alt-classification-modal-save-btn"
          >
            Uložit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

AlternativeClassificationModal.propTypes = {
  visible: propTypes.bool,
  onClose: propTypes.func,
  submitForm: propTypes.func,
  formProps: propTypes.any,
  error: propTypes.any,
  title: propTypes.string,
};

export default AlternativeClassificationModal;
